import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { GET_USER_ACHIEVEMENTS_MESSAGE_TYPE } from '#constants/message-type.constants.ts';
import { GetUserAchievementsResponse } from '#types/response.types.ts';

export const getUserAchievements = (): Promise<GetUserAchievementsResponse> =>
  SocketAsFetch.fetch({
    message_type: GET_USER_ACHIEVEMENTS_MESSAGE_TYPE,
  });
